import { List } from 'components';

const LanguagesDe: React.FC = () => {
  return (
    <List>
      <li>
        <b>Deutsch</b>
      </li>
      <li>
        <b>Englisch</b>
      </li>
      <li>
        <b>Ukrainisch</b>
      </li>
      <li>
        <b>Russisch</b>
      </li>
    </List>
  );
};

export default LanguagesDe;
